import React from 'react'
import { Popover as AntdPopover } from 'antd'

import { mergeClassName } from '../utils'

import './popover.less'

const Popover = (props) => {
  const { className, ...otherProps } = props

  return (
    <React.Fragment>
      <AntdPopover
        placement='bottom'
        overlayClassName={mergeClassName(className)}
        {...otherProps}
      />
    </React.Fragment>
  )
}

Popover.displayName = 'DmpPopover'

export default Popover
